import { render } from "./Download.vue?vue&type=template&id=43e3c163&scoped=true"
import script from "./Download.vue?vue&type=script&lang=js"
export * from "./Download.vue?vue&type=script&lang=js"

import "./Download.vue?vue&type=style&index=0&id=43e3c163&scoped=true&lang=scss"
import "./Download.vue?vue&type=style&index=1&id=43e3c163&lang=scss"

import exportComponent from "/pxplus_official_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e3c163"]])

export default __exports__